module.exports = require('./lib').default;
module.exports.default = module.exports;



/*****************
 ** WEBPACK FOOTER
 ** ./~/nuka-carousel/index.js
 ** module id = 170
 ** module chunks = 0
 **/